import { render, staticRenderFns } from "./QuizFinalCommentView.vue?vue&type=template&id=aa2c47e4&"
import script from "./QuizFinalCommentView.vue?vue&type=script&lang=js&"
export * from "./QuizFinalCommentView.vue?vue&type=script&lang=js&"
import style0 from "./QuizFinalCommentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports